import * as React from "react";
import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0.0263672L15.125 3.79843V12.2015L8 15.9736L0.875 12.2015V3.79843L8 0.0263672ZM2.375 5.49567V11.2984L7.25 13.8793V8.07655L2.375 5.49567ZM8.75 8.07655V13.8793L13.625 11.2984V5.49567L8.75 8.07655ZM12.7721 4.24999L8 1.72361L3.22795 4.24999L8 6.77637L12.7721 4.24999Z"
      fill="white"
      fillOpacity={0.85}
    />
  </svg>
);
export default SVGComponent;
